<template>
	<div class="sa-list-component">
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="visibleFields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
					<template #cell(index)="data">
						{{ data.index + 1 + (currentPage - 1) * perPage }}
					</template>
					<template v-slot:cell(statoAttuale)="row">
						<b-container class="bv-example-row">
							<stati-colors :statoLabel="row.item.statoAttuale"></stati-colors>
						</b-container>
					</template>
					<template v-slot:cell(priorita)="row">
						<b-container class="bv-example-row">
							<priorita-colors :prioritaLabel="row.item.descrizionePriorita"></priorita-colors>
						</b-container>
					</template>
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Modifica Dati Progetto" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
								<b-icon icon="pencil" variant="outline-secondary"></b-icon>
							</b-button>
							<b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Dettagli" @click="onClickDetails(row.item, row.index, $event.target)" class="mr-1 no-text">
								<i class="fab fa-creative-commons-nd"></i>
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import UtilityMixin from "../../utility/UtilityMixin";
import StatiColors from "../utility/StatiColors.vue";
import PrioritaColors from "../utility/PrioritaColors.vue";
export default {
	props: {
		visualizzaColonna: {
			type: Boolean,
			default: function () {
				return true;
			},
		},
	},
	components: { StatiColors, PrioritaColors },
	computed: {
		visibleFields() {
			return this.fields.filter((field) => field.visible);
		},
	},
	data() {
		return {
			rows: 0,
			perPage: 50,
			currentPage: 1,
			pathResource: "/gestioneattivitatasks",
			linkedit: "/gestioneattivita/tasks",
			tasksFilter: { page: null, forPage: null },
			btnAggiungi: false,
			items: [],
			fields: [
				{
					label: "#",
					key: "index",
					sortable: true,
					thStyle: "width: 3rem",
					visible: true,
				},
				{
					label: "Attivita",
					key: "nomeAttivita",
					sortable: true,
					visible: this.visualizzaColonna,
				},
				{
					label: "Task",
					key: "nome",
					sortable: true,
					visible: true,
				},
				{
					label: "Descrizione",
					key: "descrizione",
					sortable: true,
					visible: true,
				},
				{
					label: "Tem. Stim.(in ore)",
					key: "tempoStimato",
					sortable: true,
					visible: true,
				},
				{
					label: "Data Inizio",
					key: "dataOraInizio",
					thStyle: "width: 8rem",
					formatter: (value) => {
						if (value) {
							return moment(new Date(value)).format("DD/MM/YYYY");
						} else {
							return "-----";
						}
					},
					sortable: true,
					visible: true,
				},
				{
					label: "Data Fine",
					key: "dataOraFine",
					thStyle: "width: 8rem",
					formatter: (value) => {
						if (value) {
							return moment(new Date(value)).format("DD/MM/YYYY");
						} else {
							return "-----";
						}
					},
					sortable: true,
					visible: true,
				},
				{
					label: "Priorità",
					key: "priorita",
					sortable: true,
					visible: true,
				},
				{
					label: "Stato",
					key: "statoAttuale",
					sortable: true,
					thStyle: "width: 10rem",
					visible: true,
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "", visible: true },
			],
		};
	},
	watch: {
		currentPage() {
			this.loadData();
		},
	},
	methods: {
		init(params) {
			let me = this;
			me.tasksFilter = params ? params : {};
			me.loadData();
		},
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			console.log(me.tasksFilter);
			me.tasksFilter.page = me.currentPage;
			me.tasksFilter.forPage = me.perPage;
			UtilityMixin.methods.loadDataResources(me.pathResource, me.tasksFilter, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			me.$emit("afterLoadData", me.items);
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
		onEdit(item) {
			let me = this;
			me.$router.replace(me.linkedit + "/edit/" + item.id).catch((err) => {
				err;
			});
		},
		onClickDetails(item) {
			let me = this;
			me.$router.replace(me.linkedit + "/dettaglio/" + item.id).catch((err) => {
				err;
			});
		},
	},
};
</script>

<style></style>
